<div *ngIf="authError" class="auth-error">{{ authError }}</div>
<ng-container *ngIf="!authError">
  <app-card-input *ngIf="formType === 'card'" [formControl]="cardControl" [showCvc]="showCvc" [marginless]="marginless" [collectZip]="collectZip"></app-card-input>
  <app-cvc-input *ngIf="formType === 'cvc'" [formControl]="cardControl" [cardBrand]="cardBrand" [marginless]="marginless"></app-cvc-input>
</ng-container>